import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { Column, IHeaderParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IconComponent } from '@shared/components/icon/icon.component';
import { AgSetColumnsVisible } from '@shared/utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, AsyncPipe],
  templateUrl: './ag-header-collapse-columns-action.component.html',
})
export class AgHeaderCollapseColumnsActionComponent implements IHeaderAngularComp {
  change$ = new BehaviorSubject(true);
  params!: IHeaderParams;
  patientGroupsColumns: string[] = [];

  agInit(params: IHeaderParams): void {
    this.params = params;

    this.params?.api.getColumns()?.forEach((column: Column) => {
      if (column.getColId().includes('patient_group::')) {
        this.patientGroupsColumns.push(column.getColId());
      }
    });
  }

  get headerName(): string {
    return this.params?.displayName || '';
  }

  onChangeClick() {
    AgSetColumnsVisible({
      gridApi: this.params.api,
      keys: this.patientGroupsColumns,
      visible: !this.change$.getValue(),
    });
    this.params?.api.sizeColumnsToFit();
    this.change$.next(!this.change$.getValue());
  }

  refresh(): boolean {
    return false;
  }
}
